<template>
  <div class="page">
    <div>
      <div class="school-header">
        <div class="logo" @click="goHome()">
          <img src="/logo.png" />
          <span>首页</span>
        </div>
        <span class="title">学校信息设置</span>
      </div>
      <div class="form">
        <a-form layout="horizontal" :form="form">
          <!-- 头像上传 -->
          <a-form-item label="Logo上传" :labelCol="{ style: { width: '150px' } }" :wrapperCol="{ style: { flex: 1 } }">
            <c-upload ossType="avatar" :isSingle="true" accept="image/*" @uploadSuccess="uploadSuccess"
              :sourceFileList="sourceFileList"></c-upload>
          </a-form-item>

          <!-- 学校名字 -->
          <a-form-item label="学校名称" :labelCol="{ style: { width: '150px' } }" :wrapperCol="{ style: { flex: 1 } }">
            <a-input type="text" :spellcheck="false" v-decorator="[
              'schoolName',
              {
                rules: [
                  {
                    required: true,
                    pattern: /^.{2,75}$/,
                    message: '请输入长度为2~75位的学校名字',
                  },
                ],
                validateTrigger: 'change',
              },
            ]" />
          </a-form-item>

          <!-- 负责人 -->
          <a-form-item label="负责人" :labelCol="{ style: { width: '150px' } }" :wrapperCol="{ style: { flex: 1 } }">
            <a-input disabled placeholder="请选择"
              v-decorator="['nickname', { rules: [{ required: true, message: '请选择负责人' }] },]"></a-input>
          </a-form-item>
          <!-- 学校类型 -->
          <a-form-item label="学校类型" :labelCol="{ style: { width: '150px' } }" :wrapperCol="{ style: { flex: 1 } }">
            <a-select mode="multiple" placeholder="请选择" v-decorator="[
              'schoolTypeId',
              { rules: [{ required: true, message: '请选择学校类型' }] },
            ]" @change="handleChange">
              <a-select-option v-for="(item, value, index) in schoolTypeSourceList" :key="index"
                :value="value.toString()">{{ item }}</a-select-option>
            </a-select>
          </a-form-item>

          <!-- 学校属性 -->
          <a-form-item label="学校属性" :labelCol="{ style: { width: '150px' } }" :wrapperCol="{ style: { flex: 1 } }">
            <a-select class="form-cell" placeholder="请选择" v-decorator="[
              'schoolAttributeId',
              { rules: [{ required: true, message: '请选择学校属性' }] },
            ]">
              <a-select-option v-for="(item, value, index) in schoolAttributeSourceList" :key="index"
                :value="value.toString()">{{ item }}</a-select-option>
            </a-select>
          </a-form-item>
          <!--学校介绍 -->
          <a-form-item label="学校介绍" :labelCol="{ style: { width: '150px' } }" :wrapperCol="{ style: { flex: 1 } }">
            <a-textarea placeholder="请输入" :autosize="{ minRows: 2, maxRows: 6 }" v-decorator="['intro']"
              :spellcheck="false" />
          </a-form-item>

          <!-- 地区 -->
          <a-form-item label="地区" class="form-oper" :labelCol="{ style: { width: '150px' } }"
            :wrapperCol="{ style: { width: '310px' } }">
            <a-cascader :options="$store.state.common.address" placeholder="请选择"
              :fieldNames="{ label: 'name', value: 'id', children: 'children' }" v-decorator="[
                'addressSelect',
                { rules: [{ required: true, message: '请选择地区' }] },
              ]" disabled />
            <div class="explain">
              说明: 因为数据统计的关系，省市区仅在新建时确定，在新建以后不可修改
            </div>
          </a-form-item>

          <!-- 学校地址 -->
          <a-form-item label="学校地址" :labelCol="{ style: { width: '150px' } }" :wrapperCol="{ style: { flex: 1 } }">
            <a-input :spellcheck="false" type="text" v-decorator="['address']" />
            <span class="address-oper hover-font-active" @click="getAddress()">获取经纬度</span>
          </a-form-item>

          <!-- 经度 -->
          <a-form-item label="经度" :labelCol="{ style: { width: '150px' } }" :wrapperCol="{ style: { flex: 1 } }">
            <a-input-number type="text" class="address-number" v-decorator="['lng']" />
            <span>纬度：</span>
            <a-input-number type="text" class="address-number" v-decorator="['lat']" />
            <a-checkbox v-model="isAddress">开启经纬度</a-checkbox>
            <div class="desc">
              提示：开启经纬度后，老师签到需要根据经纬度范围1KM内才能签到
            </div>
          </a-form-item>
        </a-form>
        <div class="form-btn">
          <a-button type="primary" @click="submit">确认修改</a-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import user from '../../api/user'
import CUpload from '../../components/CUpload'
import Vue from 'vue'


export default {
  name: 'userCenter',
  data() {
    return {
      schoolTypeSourceList: {},
      schoolAttributeSourceList: {},
      sourceFileList: [],
      selectedItems: [],
      avatarUrl: '',
      isAddress: true,
      keyValue: false,
      schoolId: Vue.ls.get('schoolId'),
      form: this.$form.createForm(this),
    }
  },
  components: {
    CUpload,
  },
  created() {
    this.init()
    this.getSchoolInfo()
  },
  methods: {
    init() {
      let temp1 = this.$ls.get('tags').filter(item => item.tagGroup == 7)
      let temp2 = this.$ls.get('tags').filter(item => item.tagGroup == 9)
      this.schoolTypeSourceList = temp1.reduce((result, item) => {
        result[item.id] = item.tagName;
        return result;
      }, {})
      this.schoolAttributeSourceList = temp2.reduce((result, item) => {
        result[item.id] = item.tagName;
        return result;
      }, {})
    },
    getSchoolInfo() {
      user.getSchoolInfo({ schoolId: this.schoolId }).then((res) => {
        console.log('res', res)
        if (res.data) {
          const params = res.data
          this.updateData = params
          let formData = {}
          formData.schoolName = params.schoolName
          formData.managerId = params.managerId
          formData.nickname = params.nickname
          formData.agentId = params.agentId
          this.sourceFileList = [params.imgUrl]
          formData.intro = params.intro
          this.keyValue = params.keyValue == "1" ? true : false
          formData.domainName = params.domainName && params.domainName.replace(/(.khsdb.com)$/, '')
          formData.addressSelect = [
            params.provinceId,
            params.cityId,
            params.districtId,
          ]
          formData.lng = params.lng
          formData.lat = params.lat
          formData.address = params.address
          this.isAddress = params.verifyLngLat == '1'
          formData.school0 = ''
          formData.school1 = ''
          //修改入口，要记录当前学校的ID
          this.schoolId = params.id

          // 学校类型
          if (params.schoolAttributesDtos && params.schoolAttributesDtos.schoolTypeTagNames) {
            const schoolTypeTagNames = params.schoolAttributesDtos.schoolTypeTagNames
            let schoolTypeId = []
            for (let i of schoolTypeTagNames) {
              for (let j in this.schoolTypeSourceList) {
                if (i == this.schoolTypeSourceList[j]) {
                  schoolTypeId.push(j)
                }
              }
            }
            formData.schoolTypeId = schoolTypeId
          } else {
            formData.schoolTypeId = []
          }
          // 学校属性
          if (
            params.schoolAttributesDtos &&
            params.schoolAttributesDtos.schoolAttributeTagNames
          ) {
            let schoolAttributeId = ''
            for (let i in this.schoolAttributeSourceList) {
              if (params.schoolAttributesDtos.schoolAttributeTagNames == this.schoolAttributeSourceList[i]) {
                schoolAttributeId = i
                break
              }
            }
            formData.schoolAttributeId = schoolAttributeId
          } else {
            formData.schoolAttributeId = ''
          }
          // 保存数据提交接口使用
          if (params.schoolAttributesDtos) {
            this.oldSchoolAttributeMappingId = params.schoolAttributesDtos.oldSchoolAttributeMappingId || ''
            this.oldSchoolTypeMappingId = params.schoolAttributesDtos.oldSchoolTypeMappingId || []
          }
          // setTimeout(() => {
          //   this.form.setFieldsValue(formData)
          // }, 100)
          this.$nextTick(() => {
            this.form.setFieldsValue(formData)
          })
        }
      })
    },
    goHome() {
      if (Vue.ls.get('roleId') == '4') {
        this.$router.push('courseList')
      } else {
        this.$router.push('termSynopsis')
      }
    },
    //头像上传成功之后回调
    uploadSuccess(url) {
      this.avatarUrl = url
    },
    handleChange(selectedItems) {
      console.log(selectedItems)
      this.selectedItems = selectedItems
    },
    //获取经纬度
    getAddress() {
      this.form.validateFields(['addressSelect', 'address'], (err, value) => {
        console.log(value, 'valuevalue')
        let req = {
          address: value.address,
          provinceId: value.addressSelect[0],
          cityId: value.addressSelect[1],
          districtId: value.addressSelect[2],
        }
        user.getLngAndLat(req).then((res) => {
          this.form.setFieldsValue({
            lng: res.data.lng,
            lat: res.data.lat,
          })
        })
      })

    },
    analysisAddress(res) {
      let value = JSON.parse(JSON.stringify(res));
      if (!value || !value.addressSelect) return value;
      let address = value.addressSelect;
      if (address.length >= 1) {
        value.provinceId = address[0];
      }

      if (address.length >= 2) {
        value.cityId = address[1];
      }

      if (address.length >= 3) {
        value.districtId = address[2];
      }
      delete value.addressSelect;
      return value;
    },
    submit() {
      this.form.validateFields((err, value) => {
        console.log('输入的内容是：', value)
        //头像
        value.imgUrl = this.avatarUrl || this.sourceFileList[0]
        // 是否开通
        value.keyValue = this.keyValue == true ? 1 : 0
        if (!this.keyValue) {
          value.domainName = null
        } else {
          value.domainName = value.domainName && value.domainName + '.khsdb.com'
        }
        console.log(value, 'domaindomain')
        //校验通过 and 判断是否上传头像
        if (!err) {
          let tempValue = this.analysisAddress(value)
          tempValue.verifyLngLat = this.isAddress ? '1' : '0'
          tempValue.schoolName = tempValue.schoolName.trim()
          if (!tempValue.schoolName.length) {
            this.$message.error('学校名称不能为空')
            return
          }
          console.log('tempValue', tempValue)
          tempValue.oldSchoolAttributeMappingId = this.oldSchoolAttributeMappingId
          tempValue.oldSchoolTypeMappingId = this.oldSchoolTypeMappingId
          user.updateSchoolInfo(this.schoolId, tempValue).then(res => {
            this.$message.success('修改成功')
            this.getSchoolInfo()
          })
        }
      })
    }
  },
}
</script>
<style lang="scss" scoped>
.page {
  max-width: 100vw;
  min-width: 600px;
  display: flex;
  justify-content: center;
  padding-top: 100px;
}

.school-header {
  display: flex;
  align-items: center;
  text-align: left;
  padding: 0px 6px 18px;
  position: relative;

  .logo {
    display: inline-block;
    position: relative;
    padding-right: 10px;
    cursor: pointer;

    img {
      width: 38px;
      height: auto;
      margin-right: 6px;
      vertical-align: middle;
    }

    span {
      font-size: 20px;
      font-weight: 600;
      vertical-align: middle;
    }
  }

  .logo::after {
    content: '';
    width: 1px;
    height: 16px;
    position: absolute;
    top: 11px;
    right: 0px;
  }

  .title {
    vertical-align: middle;
    display: inline-block;
    padding-left: 10px;
    font-weight: 600px;
    font-size: 16px;
  }
}

.form {
  border: 1px solid #ededed;
  border-bottom: none;
  width: 600px;
  min-width: 600px;
  padding: 24px 0 40px;
}

.address-oper {
  position: absolute;
  top: -11px;
  right: -80px;
}

.address-number {
  width: 128px !important;
  display: inline-block;
  margin-right: 10px;
}

.address-number:last-child {
  margin-right: 0px;
}

.desc {
  font-size: 12px;
  line-height: 30px;
}

.explain {
  margin-top: 8px;
  color: #8B8B7A;
  line-height: 25px;
  font-size: 15px;
}

.form-btn {
  text-align: center;
  margin: 15px 0;
}

.ant-form-item {
  display: flex !important;
  margin-right: 0 !important;
  padding-right: 30px;
  min-width: 600px !important;
}

.ant-select,
.ant-input {
  width: 310px !important;
}
</style>
